import { CategoryQueryModel } from 'app/core';
import {
    NewTableDef,
    TableColumnDef,
} from 'app/shared/tables/table-column-def';

export class MainProductListQuery {
    Ean: number;
    Id: number;
    ActiveFlag: number;
    Brand: string;
    BrandKind: string;
    Code: number;
    CreatedAt: string;
    DateFrom: string;
    DateTo: string;
    DiscountAvg: number;
    DiscountedPriceAvg: number;
    Manufacturer: string;
    Margin: number;
    MarginAvg: number;
    MaxSupplierPrice: number;
    MinMargin: number;
    OriginCountry: string;
    PckgType: string;
    PrcStrategy: string;
    PrcType: number;
    PriceSegment: string;
    Name: string;
    Descripion: string;
    InternalId: number;
    QtyInPackage: number;
    SalesQty: number;
    Sensitivity: string;
    Status: string;
    SubBrand: string;
    UnitOfMeasure: string;
    UnitPrchPrcNet: number;
    UnitPurchasePriceNetAvg: number;
    UnitSalesPrcGross: number;
    UnitSalesPrcNet: number;
    UnitSalesPriceGrossAvg: number;
    UnitSalesPriceGrossMax: number;
    UnitSalesPriceGrossMin: number;
    VatOfSales: number;
    Weight: number;
    CategoryNameLevel1: string;
    CategoryNameLevel2: string;
    CategoryNameLevel3: string;
    ProductLogicRelationExist: string;

    public static tableInfo(): NewTableDef {
        return {
            tableId: 'MainProductListQuery',
            columns: [
                { columnDef: 'Id' },
                {
                    field: 'Ean',
                    columnDef: 'Ean',
                    header: 'ean',
                    filterValue: 'EANs',
                    width: 8,
                    type: 'number',
                    tooltipEnabled: true,
                },
                {
                    field: 'Code',
                    columnDef: 'Code',
                    header: 'ckt',
                    filterValue: 'Codes',
                    width: 6,
                    type: 'number',
                    tooltipEnabled: true,
                },
                {
                    field: 'Name',
                    columnDef: 'Name',
                    header: 'Nazwa SKU',
                    width: 18.5,
                    isGeneralSearchColumn: true,
                    tooltipEnabled: true,
                },
                {
                    field: 'CategoryName',
                    columnDef: 'CategoryName',
                    header: 'Kategoria',
                    sortColumnDef: 'CategoryNameLevel1',
                    filterValue: 'Categories',
                    width: 11,
                    tooltipEnabled: true
                },
                {
                    field: 'Manufacturer',
                    columnDef: 'Manufacturer',
                    header: 'Dostawca',
                    filterValue: 'Suppliers',
                    width: 10,
                    tooltipEnabled: true,
                },
                {
                    field: 'Status',
                    columnDef: 'Status',
                    header: 'status',
                    width: 6,
                },
                {
                    field: 'UnitPrchPrcNet',
                    columnDef: 'UnitPrchPrcNet',
                    header: 'cena zak net',
                    width: 9,
                    suffix: 'currency',
                    type: 'currency',
                    showSearch: false,
                },
                {
                    field: 'VatOfSales',
                    columnDef: 'VatOfSales',
                    header: 'vat',
                    width: 5,
                    suffix: 'percentage',
                    type: 'vat',
                    showSearch: false,
                },
                {
                    field: 'UnitSalesPrcGross',
                    columnDef: 'UnitSalesPrcGross',
                    header: 'cena sprz brutto',
                    width: 8,
                    suffix: 'currency',
                    type: 'currency',
                    showSearch: false,
                },
                {
                    field: 'Margin',
                    columnDef: 'Margin',
                    header: 'Marża (%)',
                    width: 8,
                    type: 'margin',
                    showSearch: false,
                },
                {
                    field: 'ProductLogicRelationExist',
                    columnDef: 'ProductLogicRelationExist',
                    header: 'powiązane',
                    width: 7,
                    filterValue: 'ProductLogicRelationExist',
                },
            ],
        };
    }
}

export class ProductListExpandModel {
    Id: number;
    InternalId: number;
    AnalyticProductId: number;
    Ean: number;
    Code: number;
    Name: string;
    Descripion: string;
    UnitOfMeasure: string;
    Weight: number;
    QtyInPackage: number;
    Manufacturer: string;
    ActiveFlag: number;
    Status: string;
    Brand: string;
    SubBrand: string;
    BrandKind: string;
    PckgType: string;
    OriginCountry: string;
    CreatedAt: string;
    PriceSegment: string;
    PositionId: number;
    PositionDs: string;
    SensitivityId: number;
    SensitivityDs: string;
    MinMargin: number;
    MaxSupplierPrice: number;
    CategoryId: number;
    Category: {
        Name: string;
        CategoryMap: Array<CategoryMapModel>;
    };
}

export class CategoryMapModel {
    Id: number;
    InternalId: number;
    Level: number;
    Name: string;
}

export class ProductDescriptionQuery {
    Id: number;
    InternalId: number;
    AnalyticProductId: number;
    Ean: number;
    Code: number;
    Name: string;
    Descripion: string;
    UnitOfMeasure: string;
    Weight: number;
    QtyInPackage: number;
    Manufacturer: string;
    ActiveFlag: number;
    Status: string;
    Brand: string;
    SubBrand: string;
    BrandKind: string;
    PckgType: string;
    OriginCountry: string;
    CreatedAt: string;
    PriceSegment: string;
    PositionId: number;
    PositionDs: string;
    SensitivityId: number;
    SensitivityDs: string;
    MinMargin: number;
    MaxSupplierPrice: number;
    CategoryId: number;
    Sale: ProductSales[];
    Category: CategoryQueryModel;
}

export class ProductDescriptionModel {
    Id: number;
    InternalId: number;
    Ean: number;
    Code: number;
    Name: string;
    Description: string;
    UnitOfMeasure: string;
    Weight: number;
    QtyInPackage: number;
    Manufacturer: string;
    ActiveFlag: number;
    Status: string;
    Brand: string;
    SubBrand: string;
    BrandKind: string;
    PckgType: string;
    MinMargin: number;
    MaxMargin: number;
    MaxSupplierPrice: number;
    PriceSegment: string;
    CategoryLevel1: CategoryMapModel;
    CategoryLevel2: CategoryMapModel;
    CategoryLevel3: CategoryMapModel;
    Sale: ProductSale;
    Sensitivity: string;
    CategoryRole: string;
    Alert: { Message: string };
    IsProductDependent: boolean;
    IsProductMain: boolean;
    // for --aot to pass
    PositionDs: string;
    CreatedAt: string;
    UseMinMargin: boolean;
    UseMaxMargin: boolean;
}

export class ProductSale {
    SalesQty: number;
    UnitSalesPriceGrossAvg: number;
    UnitSalesPriceGrossMax: number;
    UnitSalesPriceGrossMin: number;
    UnitPurchasePriceNetAvg: number;
    DiscountAvg: number;
    DiscountedPriceAvg: number;
    CompetitorPriceAvg: number;
    MarginAvg: number;
    VatOfSales: number;
    PrcType: number;
}

export class ProductSales {
    CompetitorPriceAvg: number;
    DiscountAvg: number;
    DiscountedPriceAvg: number;
    Id: number;
    MarginAvg: number;
    Period: string;
    PrcType: number;
    ProductId: number;
    SalesQty: number;
    StoreId: number;
    UnitPurchasePriceNetAvg: number;
    UnitSalesPriceGrossAvg: number;
    UnitSalesPriceGrossMax: number;
    UnitSalesPriceGrossMin: number;
    VatOfSales: number;
}

export class ProductPriceSetQuery {
    productId: number;
    price: string;
    value: number;

    constructor(id: number, type: string, price: number) {
        this.productId = id;
        this.price = type;
        this.value = price;
    }
}

export class SetPriceModel {
    productId: number;
    minMargin: number;
    maxMargin: number;
    maxSupplierPrice: number;
    useMinMargin: boolean;
    useMaxMargin: boolean;

    constructor(id: number, maxSup: number, minMarg: number, maxMarg: number, useMinMargin: boolean, useMaxMargin: boolean) {
        this.productId = id;
        this.minMargin = minMarg;
        this.maxMargin = maxMarg;
        this.maxSupplierPrice = maxSup;
        this.useMinMargin = useMinMargin;
        this.useMaxMargin = useMaxMargin;
    }
}

export class ProductPriceEditableQuery {
    ProductId: number;
    Price: string;
    Value: number;
}

export class ProducPrictResultCommand {
    actionName: string;
    message: string;
}

export class ProductPriceCommand {
    commandName: string;
    completed: boolean;
    result: ProducPrictResultCommand;
}

export enum ProductStatusEnum {
    Aktywny = 'AK',
    Nieaktywny = 'NZ',
}

export class ProductStorePricesListQuery {
    StoreId: number;
    StoreName: string;
    GrossRevenue: number;
    GrossRevenueValue: number;
    QtyInStock: number;
    UnitSalesPriceGross: number;
    UnitPurchasePriceNet: number;
    Margin: number;
    DateFrom: string;
    DateTo: string;
    DateLastSale: string;

    public static tableInfo(): NewTableDef {
        return {
            tableId: 'ProductStorePricesListQuery',
            columns: [
                { columnDef: 'StoreId' },
                {
                    field: 'StoreId',
                    columnDef: 'StoreId',
                    header: 'ID placówki',
                    width: 5,
                },
                {
                    field: 'StoreName',
                    columnDef: 'StoreName',
                    header: 'Nazwa placówki',
                    filterValue: 'StoreNames',
                    isGeneralSearchColumn: true,
                    width: 20,
                    tooltipEnabled: true,
                },
                {
                    field: 'GrossRevenue',
                    columnDef: 'GrossRevenue',
                    header: 'Obrót il (szt.)',
                    width: 10,
                },
                {
                    field: 'QtyInStock',
                    columnDef: 'QtyInStock',
                    header: 'Zapas (szt.)',
                    width: 10,
                },
                {
                    field: 'UnitPurchasePriceNet',
                    columnDef: 'UnitPurchasePriceNet',
                    header: 'cena zakupu',
                    width: 8,
                    suffix: 'currency',
                    type: 'currency',
                },
                {
                    field: 'UnitSalesPriceGross',
                    columnDef: 'UnitSalesPriceGross',
                    header: 'cena sprzed',
                    width: 8,
                    suffix: 'currency',
                    type: 'currency',
                },
                {
                    field: 'PriceType',
                    columnDef: 'PriceType',
                    header: 'typ ceny',
                    width: 6,
                },
                {
                    field: 'Margin',
                    columnDef: 'Margin',
                    header: 'Marża (%)',
                    width: 8,
                    type: 'margin',
                },
                {
                    field: 'DateFrom',
                    columnDef: 'DateFrom',
                    header: 'data ceny od',
                    width: 8,
                    type: 'date',
                },
                {
                    field: 'DateTo',
                    columnDef: 'DateTo',
                    header: 'data ceny do',
                    width: 8,
                    type: 'date',
                },
                {
                    field: 'DateLastSale',
                    columnDef: 'DateLastSale',
                    header: 'data ostatniej sprzed',
                    width: 9,
                    type: 'date',
                },
            ],
        };
    }
}

export class ProductLogicsBrowserList {
    Id: number;
    Name: string;
    CategoryLevel1Name: string;
    Ean: string;
    Weight: number;
    IsProductMain: boolean;
    IsProductDependent: boolean;
    ProductLogicRelationExist: string;

    public static tableInfo(): NewTableDef {
        return {
            tableId: 'ProductLogicsBrowser',
            columns: [
                { columnDef: 'Id' },
                {
                    field: 'Name',
                    columnDef: 'Name',
                    header: 'Nazwa SKU',
                    isGeneralSearchColumn: true,
                    width: 25,
                    tooltipEnabled: true,
                },
                {
                    field: 'CategoryName',
                    columnDef: 'CategoryName',
                    sortColumnDef: 'CategoryNameLevel1',
                    header: 'Nazwa kategorii',
                    filterValue: 'Categories',
                    width: 25,
                    tooltipEnabled: true

                },
                {
                    field: 'Ean',
                    columnDef: 'Ean',
                    header: 'Kod EAN',
                    filterValue: 'EANs',
                    filterNameProp: 'Ean',
                    type: 'number',
                    searchByEq: true,
                    width: 20,
                },
                {
                    field: 'Weight',
                    columnDef: 'Weight',
                    header: 'Gramatura',
                    width: 10,
                },
                {
                    field: 'ProductLogicRelationExist',
                    columnDef: 'ProductLogicRelationExist',
                    header: 'powiązane',
                    width: 10,
                    filterValue: 'ProductLogicRelationExist',
                },
            ],
        };
    }
}

export class ProductLogicsMainDependenciesList {
    Id: number;
    Name: string;
    CategoryLevel1Name: string;
    Ean: string;
    Coefficent: number;
    LowerIndex: number;
    TopIndex: number;
    RelationName: string;
    Weight: number;
    // this field is needed to sync left and right tables
    IsProductDependent: boolean;

    public static tableInfo(): NewTableDef {
        return {
            tableId: 'ProductLogicsMainDependenciesList',
            columns: [
                { columnDef: 'Id' },
                {
                    field: 'Name',
                    columnDef: 'Name',
                    header: 'Nazwa SKU',
                    width: 25,
                    tooltipEnabled: true,
                },
                {
                    field: 'CategoryName',
                    columnDef: 'CategoryName',
                    sortColumnDef: 'CategoryNameLevel1',
                    header: 'Nazwa kategorii',
                    filterValue: 'Categories',
                    width: 25,
                    tooltipEnabled: true
                },
                {
                    field: 'Ean',
                    columnDef: 'Ean',
                    header: 'Kod EAN',
                    filterValue: 'EANs',
                    width: 20,
                },
                {
                    field: 'Coefficent',
                    columnDef: 'Coefficent',
                    header: 'Wsp. powiązania',
                    showSearch: false,
                    width: 10,
                },
                {
                    field: 'LowerIndex',
                    columnDef: 'LowerIndex',
                    header: 'Index min.',
                    showSearch: false,
                    width: 10,
                },
                {
                    field: 'TopIndex',
                    columnDef: 'TopIndex',
                    header: 'Index max.',
                    showSearch: false,
                    width: 10,
                },
            ],
        };
    }

    public static unSelectTableInfo(): NewTableDef {
        return {
            tableId: 'unSelectTableInfo',
            columns: [
                { columnDef: 'Id' },
                {
                    field: 'Name',
                    columnDef: 'Name',
                    header: 'Nazwa SKU',
                    width: 20,
                },
                {
                    field: 'Ean',
                    columnDef: 'Ean',
                    header: 'Kod EAN',
                    filterValue: 'EANs',
                    filterNameProp: 'Ean',
                    searchValue: 'EanCode',
                    searchByEq: true,
                    width: 20,
                },
                {
                    field: 'Coefficent',
                    columnDef: 'Coefficent',
                    header: 'Wsp. powiązania',
                    width: 10,
                    additional: true,
                    showSearch: false,
                    color: 'primary',
                },
                {
                    field: 'LowerIndex',
                    columnDef: 'LowerIndex',
                    header: 'Indek min',
                    width: 10,
                    additional: true,
                    showSearch: false,
                    color: 'primary',
                },
                {
                    field: 'TopIndex',
                    columnDef: 'TopIndex',
                    header: 'Indek max',
                    width: 10,
                    additional: true,
                    showSearch: false,
                    color: 'primary',
                },
                {
                    field: 'RelationName',
                    columnDef: 'RelationName',
                    header: 'Nazwa powiązania',
                    width: 20,
                    additional: true,
                    showSearch: false,
                    color: 'primary',
                },
            ],
        };
    }
}

export interface ProductLogicsCreatingForm {
    MainProductId: number;
    DependentProductsList: {
        Id: number;
        RelationName: string;
        Coefficent: number;
        TopIndex: number;
        LowerIndex: number;
    }[];
}

export enum ProductLogicOptionsEnum {
    default = 0,
    main = 1,
    dependent = 2,
}

export class ProductLogicModalListModel {
    Id: number;
    Ean: number;
    Name: string;
    CategoryNameLevel1: string;

    public static tableInfoMiniForExpand(): Array<TableColumnDef> {
        return [
            { columnDef: 'Id' },
            {
                columnDef: 'Name',
                sortColumnDef: 'Name',
                header: 'Nazwa SKU',
                isGeneralSearchColumn: true,
                width: 25,
            },
            {
                columnDef: 'Ean',
                sortColumnDef: 'EAN',
                filterValue: 'EANs',
                header: 'Nazwa SKU',
                width: 25,
            },
            {
                field: 'CategoryLevel2Name',
                columnDef: 'CategoryLevel2Name',
                filterValue: 'CategoryNamesLevel2',
                header: 'Kategoria 2',
                filterNameProp: 'CategoryLevel2Name',
                width: 25,
            },
            {
                field: 'CategoryLevel3Name',
                columnDef: 'CategoryLevel3Name',
                filterValue: 'CategoryNamesLevel3',
                header: 'Kategoria 3',
                filterNameProp: 'CategoryLevel3Name',
                width: 25,
            },
        ];
    }
}

export interface ProductLogicsMainProductForDependent {
    Id: number;
    Name: string;
    RelationName: string;
}
